// src/pages/tournament/roundsState.js
// Pure helpers for updating the nested rounds -> matchups -> matches -> sets state immutably.

export const updateRound = (rounds, roundId, update) =>
    rounds.map((round) => (round.roundId === roundId ? update(round) : round));

export const updateMatchup = (rounds, roundId, matchupId, update) =>
    updateRound(rounds, roundId, (round) => ({
        ...round,
        matchups: round.matchups.map((matchup) => (matchup.matchupId === matchupId ? update(matchup) : matchup)),
    }));

export const updateMatch = (rounds, roundId, matchupId, matchId, update) =>
    updateMatchup(rounds, roundId, matchupId, (matchup) => ({
        ...matchup,
        matches: (matchup.matches || []).map((match) => (match.matchId === matchId ? update(match) : match)),
    }));

export const updateSet = (rounds, roundId, matchupId, matchId, setId, update) =>
    updateMatch(rounds, roundId, matchupId, matchId, (match) => ({
        ...match,
        sets: (match.sets || []).map((set) => (set.setId === setId ? update(set) : set)),
    }));

// Sets won by each team in a match (unplayed 0-0 sets and draws count for nobody).
export function setsWon(match) {
    const won = { team1: 0, team2: 0 };
    for (const set of match.sets || []) {
        if (set.team1Score > set.team2Score) won.team1 += 1;
        if (set.team2Score > set.team1Score) won.team2 += 1;
    }
    return won;
}
